module.exports = __webpack_public_path__ + "cfd0638cb0ab8b5ac795d028293fbaf3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/skaters-shack.png
// module id = 596
// module chunks = 0